import {
  TRACKING_TOGGLE_SAVE_ERROR,
  TRACKING_TOGGLE_SAVE,
  TRACKING_TOGGLE_CHANGE,
} from '../actions/tracking';
import {
  DANGEROUS_CONFIG_RECEIVE,
  SESSION_RECEIVE,
} from '../../../globals/actions';

import { REMOVE_INTEREST, ADD_INTEREST } from '../actions/personalization';

import {
  readPersonalizationSettings,
  writePersonalizationSettings,
} from '../storage/personalization';

export default (state, action) => {
  if (!state) {
    return {
      tracking: {},
    };
  }

  switch (action.type) {
    case DANGEROUS_CONFIG_RECEIVE: {
      return {
        ...state,
        tracking: {
          settings: action.market.trackingToggles.reduce(
            (settings, setting) => ({
              ...settings,
              [setting.name]: setting.default,
            }),
            []
          ),
        },
      };
    }

    case SESSION_RECEIVE: {
      return {
        ...state,
        tracking: {
          ...state.tracking,
          settings: {
            ...state.tracking.settings,
            ...Object.keys(action.privacyCookie || {}).reduce(
              (settings, curr) =>
                Object.assign(settings, {
                  [curr]: Boolean(action.privacyCookie[curr]),
                }),
              {}
            ),
          },
        },
        personalization: {
          clientId: action.clientId,
          pulseEnvironmentId: action.pulseEnvironmentId,
        },
      };
    }

    case TRACKING_TOGGLE_CHANGE: {
      return {
        ...state,
        tracking: {
          ...state.tracking,
          settings: {
            ...state.tracking.settings,
            [action.name]: action.active,
          },
        },
      };
    }

    case TRACKING_TOGGLE_SAVE: {
      return {
        ...state,
        tracking: {
          ...state.tracking,
          settings: {
            ...state.tracking.settings,
            ...action.settings,
          },
          success: true,
        },
      };
    }

    case TRACKING_TOGGLE_SAVE_ERROR: {
      return {
        ...state,
        tracking: { ...state.tracking, error: true },
      };
    }

    case REMOVE_INTEREST: {
      const { id } = action;
      const personalizationSettings = readPersonalizationSettings();
      const { notInterestedIn } = personalizationSettings;
      const { categories } = notInterestedIn;

      writePersonalizationSettings({
        ...personalizationSettings,
        notInterestedIn: {
          ...notInterestedIn,
          categories: [...categories, { id }],
        },
      });

      return state;
    }

    case ADD_INTEREST: {
      const { id } = action;
      const personalizationSettings = readPersonalizationSettings();
      const { notInterestedIn } = personalizationSettings;
      const { categories } = notInterestedIn;

      writePersonalizationSettings({
        ...personalizationSettings,
        notInterestedIn: {
          ...notInterestedIn,
          categories: categories.filter(category => category.id !== id),
        },
      });

      return state;
    }

    default:
      return state;
  }
};
